import React from 'react';
import { Box, Typography, Button, Grid, Divider } from '@mui/material';
import PageCard from './PageCard';

const TabPagina = ({ paginas, irA, eliminar }) => {
  // Grupo/negocio o independiente: el tipo guardado de la página (las de antes: grupo si tienen a alguien más en el equipo)
  const esGrupo = p => (p.tipo ? p.tipo === 'grupo' : (p.miembros || []).length > 1);
  const drafts = paginas.filter(p => p.borrador);
  const published = paginas.filter(p => !p.borrador);
  const independent = published.filter(p => !esGrupo(p));
  const groups = published.filter(esGrupo);

  return (
    <Box sx={{ mt: 3 }}>
      {/* Drafts Section */}
      {drafts.length > 0 && (
        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" color="primary.main">
            Borradores
          </Typography>
          <Typography color="text.secondary" sx={{ mb: 2 }}>
            Completa la información de tu servicio para publicarlo
          </Typography>

          {drafts.map(page => (
            <PageCard
              key={page._id}
              page={page}
              type="DRAFT"
              onEdit={() => irA(`/user/crear-servicio/1?draft=${page._id}`)} // Adjust route needed
              onView={() => irA(`/user/pagina/${page._id}`)}
              onDelete={() => eliminar(page._id)}
            />
          ))}
        </Box>
      )}

      {/* Independent Section */}
      <Box sx={{ mb: 6 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Typography variant="h6" fontWeight="bold" color="primary.main">
            Mis páginas de Servicios Independientes
          </Typography>
          <Button
            variant="contained"
            color="primary"
            // py grande solo en pantallas pequeñas (donde el texto se aprieta); en desktop, padding normal
            sx={{ textTransform: 'none', bgcolor: 'primary.main', py: { xs: 3.5, md: 0.75 } }}
            onClick={() => irA('/user/crear-servicio/1?type=independent')}
          >
            Nueva página independiente
          </Button>
        </Box>
        <Typography color="text.secondary" sx={{ mb: 2 }}>
          Tus páginas donde eres el único profesional
        </Typography>

        {independent.length === 0 ? (
          <Typography sx={{ mt: 2, color: "text.secondary" }}>
            No tienes páginas independientes aún.
          </Typography>
        ) : (
          independent.map(page => (
            <PageCard
              key={page._id}
              page={page}
              type="PUBLISHED"
              onEdit={() => irA(`/user/crear-servicio/1?edit=${page._id}&type=independent`)}
              onView={() => irA(`/user/pagina/${page._id}`)} // Adjust route
              onDelete={() => eliminar(page._id)}
            />
          ))
        )}
      </Box>

      {/* Groups Section */}
      <Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Typography variant="h6" fontWeight="bold" color="primary.main">
            Mis páginas de Grupos y Negocios
          </Typography>
          <Button
            variant="contained"
            sx={{ textTransform: 'none', bgcolor: 'primary.main', py: { xs: 3.5, md: 0.75 }, '&:hover': { bgcolor: 'primary.dark' } }}
            onClick={() => irA('/user/crear-servicio/1?type=group')}
          >
            Nueva página de grupo
          </Button>
        </Box>
        <Typography color="text.secondary" sx={{ mb: 2 }}>
          Tus páginas con equipos y colaboradores
        </Typography>

        {groups.length === 0 ? (
          <Typography sx={{ mt: 2, color: "text.secondary" }}>
            No tienes páginas de grupos o negocios aún.
          </Typography>
        ) : (
          groups.map(page => (
            <PageCard
              key={page._id}
              page={page}
              type="PUBLISHED"
              onEdit={() => irA(`/user/crear-servicio/1?edit=${page._id}&type=group`)}
              onView={() => irA(`/user/pagina/${page._id}`)} // Adjust route
              onDelete={() => eliminar(page._id)}
            />
          ))
        )}
      </Box>
    </Box>
  );
};

export default TabPagina;
